import { Popover as BasePopover } from "@base-ui/react/popover";
import clsx from "clsx";
import type { ReactElement, ReactNode } from "react";
import popupStyles from "../Popup/Popup.module.css";
import styles from "./Popover.module.css";

export interface PopoverProps {
  /** The element that toggles the popover (usually a Button). */
  trigger: ReactElement;
  /** Optional heading; also labels the popover. */
  title?: ReactNode;
  children: ReactNode;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  side?: "top" | "right" | "bottom" | "left";
  align?: "start" | "center" | "end";
  className?: string;
}

/** Quick details or a small edit next to its trigger (Base UI Popover). Prefer it to a dialog for quick edits. */
export function Popover({
  trigger,
  title,
  children,
  open,
  onOpenChange,
  side = "bottom",
  align = "center",
  className,
}: PopoverProps) {
  return (
    <BasePopover.Root open={open} onOpenChange={onOpenChange ? (next) => onOpenChange(next) : undefined}>
      <BasePopover.Trigger render={trigger} />
      <BasePopover.Portal>
        <BasePopover.Positioner
          className={popupStyles.positioner}
          side={side}
          align={align}
          sideOffset={6}
          collisionPadding={8}
        >
          <BasePopover.Popup className={clsx(popupStyles.popup, styles.popup, className)}>
            {title ? <BasePopover.Title className={styles.title}>{title}</BasePopover.Title> : null}
            {children}
          </BasePopover.Popup>
        </BasePopover.Positioner>
      </BasePopover.Portal>
    </BasePopover.Root>
  );
}
